import _typeof from '@babel/runtime/helpers/typeof';
import React__default from 'react';
import { useDesignSystemThemeName, generateId } from '../utils.js';
import { StyledLabel, RadioGroupWrapper } from './Radio.styles.js';

var Radio = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var className = props.className,
      children = props.children,
      name = props.name,
      value = props.value,
      checked = props.checked,
      defaultChecked = props.defaultChecked,
      disabled = props.disabled,
      onChange = props.onChange,
      dataTestId = props['data-test-id'];
  var themeName = useDesignSystemThemeName();
  var randomId = generateId();
  var classNames = "\n    sok-radio\n    ".concat(themeName, "\n    ").concat(className || '', "\n  ");
  return /*#__PURE__*/React__default.createElement(StyledLabel, {
    className: classNames.replace(/\s*\n\s*/g, ' '),
    htmlFor: randomId,
    disabled: disabled,
    "data-test-id": dataTestId
  }, /*#__PURE__*/React__default.createElement("input", {
    className: "".concat(disabled ? 'disabled' : ''),
    id: randomId,
    type: "radio",
    name: name,
    value: value,
    ref: ref,
    checked: _typeof(checked) === undefined ? undefined : checked,
    defaultChecked: defaultChecked,
    disabled: disabled,
    onChange: onChange
  }), children, /*#__PURE__*/React__default.createElement("span", {
    className: "checkmark"
  }));
});
Radio.displayName = 'Radio';

var RadioGroup = function RadioGroup(props) {
  var className = props.className,
      options = props.options,
      name = props.name,
      defaultValue = props.defaultValue,
      dataTestId = props['data-test-id'];
  var themeName = useDesignSystemThemeName();
  var classNames = "\n    sok-radio-group\n    ".concat(themeName, "\n    ").concat(className || '', "\n  ");
  return /*#__PURE__*/React__default.createElement(RadioGroupWrapper, {
    className: classNames.replace(/\s*\n\s*/g, ' '),
    "data-test-id": dataTestId
  }, options && options.map(function (option, index) {
    return /*#__PURE__*/React__default.createElement(Radio, {
      key: Math.random(),
      value: option.value,
      name: name,
      defaultChecked: option.value === defaultValue,
      disabled: option.disabled || false,
      onChange: function onChange(e) {
        if (!props.onChange) {
          return;
        }

        props.onChange(e, e.target.value);
      },
      "data-test-id": "".concat(dataTestId, "-groupItem-").concat(index)
    }, option.text);
  }));
};

Radio.defaultProps = {
  'data-test-id': 'Radio'
};
RadioGroup.defaultProps = {
  'data-test-id': 'RadioGroup'
};

export { Radio, RadioGroup, Radio as default };
//# sourceMappingURL=Radio.js.map
